export const AuthRequestStatus = {
    AUTH_NUM_REQUESTED_BEFORE: "AUTH_NUM_REQUESTED_BEFORE" /* 인증번호 요청 전 */,
    AUTH_NUM_REQUESTED_AFTER: "AUTH_NUM_REQUESTED_AFTER" /* 인증번호 요청 후 */,
    AUTH_NUM_SENT_COMPLETED: "AUTH_NUM_SENT_COMPLETED" /* 인증번호 발송 완료 */,
    AUTH_NUM_VERIFIED: "AUTH_NUM_VERIFIED" /* 인증번호 검증 완료 */,
};

export const AuthCodeStatus = {
    WAITING: "WAITING",   /* 대기 */
    IN_PROGRESS: "IN_PROGRESS",   /* 진행중 */
    TIMEOUT: "TIMEOUT",   /* 타임아웃 */
};